import storage from "web/script/utils/storage";
import environment from "web/script/modules/environment";
import { openGenericModal } from "web/redux/ducks/send-to-app-modal";
import store from "web/redux/store";

const OVERLAY_TIMER_OPTIONS = {
    time_1: 10000,
    time_2: 20000,
    time_3: 30000,
};

function WebToAppBlockController(remainingSessionTimer): void {
    const timeVariant = String(environment.getFeature("mg_show_timed_app_download_block"));
    let setTime = OVERLAY_TIMER_OPTIONS[timeVariant] - remainingSessionTimer;

    if (timeVariant) {
        setTime = setTime > 0 ? setTime : 100;
        setTimeout(function () {
            // check storage and see if user has seen a block and had made an interaction
            const appBlockShown = storage.get("appBlockShown", null, true);
            if (!appBlockShown.hasBeenBlocked && !appBlockShown.isLoadingNextPage) {
                store.dispatch(
                    openGenericModal({
                        modalType: "timed-modal",
                        paywalledClassName: "timed-modal",
                        product: null,
                    })
                );
            }
        }, setTime);
    }
}

const sessionTimer = {
    // Called when a valid interaction is made.
    onChange(): void {
        const appBlockShown = storage.get("appBlockShown", null, true);
        if (appBlockShown && appBlockShown.hasInteraction) {
            const storedSessionStart = storage.get("sessionTimer", { startTime: Date.now() }, true);
            storage.set("sessionTimer", storedSessionStart, true);
            WebToAppBlockController(Date.now() - storedSessionStart.startTime);
        }
    },
    // onPageLoad we clean the isLoadingNextPage because the redirect is complete
    onPageLoad(): void {
        const appBlockShown = storage.get(
            "appBlockShown",
            { hasBeenBlocked: false, hasInteraction: false },
            true
        );
        storage.set(
            "appBlockShown",
            {
                ...appBlockShown,
                isLoadingNextPage: false,
            },
            true
        );
        this.onChange();
    },
};

export default sessionTimer;
